import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import TextBoxType from '@/Controls/TextBox';
import HiddenType from '@/Controls/Hidden';
import LinkType from '@/Controls/Link';
import AssociationBoxViewModelType from '@/ViewModels/Controls/AssociationBoxViewModel';

export default class AssociationBox extends Control {

    private TextBox = ComponentManager.getControl<typeof TextBoxType>('TextBox');
    private Hidden = ComponentManager.getControl<typeof HiddenType>('Hidden');
    private Link = ComponentManager.getControl<typeof LinkType>('Link');
    private jQueryControl: JQuery;
    private textBox: TextBoxType;
    private hidden: HiddenType;
    private linkCreate: LinkType;
    private linkSelect: LinkType;
    private linkEdit: LinkType;
    private linkDisconnect: LinkType;
    private linkDelete: LinkType;

    constructor(private viewModel: AssociationBoxViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div>');

        this.widget(null);

        return this.jQueryControl;
    }

    public addLabelReference(label: JQuery): JQuery {
        return this.textBox.addLabelReference(label);
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'associationbox',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            invalid: this.viewModel.invalidationText,

            visible: this.viewModel.isVisible,

            styles: this.definePureComputed({
                read: () => {
                    let styles = ['default'];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            })
        });

        if (this.viewModel.textBox != null) {
            this.textBox = new this.TextBox(this.viewModel.textBox);
            let tuple = this.textBox.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }

        if (this.viewModel.hidden != null) {
            this.hidden = new this.Hidden(this.viewModel.hidden);
            let tuple = this.hidden.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }

        if (this.viewModel.linkCreate != null) {
            this.linkCreate = new this.Link(this.viewModel.linkCreate);
            let tuple = this.linkCreate.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }

        if (this.viewModel.linkSelect != null) {
            this.linkSelect = new this.Link(this.viewModel.linkSelect);
            let tuple = this.linkSelect.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }

        if (this.viewModel.linkEdit != null) {
            this.linkEdit = new this.Link(this.viewModel.linkEdit);
            let tuple = this.linkEdit.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }

        if (this.viewModel.linkDisconnect != null) {
            this.linkDisconnect = new this.Link(this.viewModel.linkDisconnect);
            let tuple = this.linkDisconnect.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }

        if (this.viewModel.linkDelete != null) {
            this.linkDelete = new this.Link(this.viewModel.linkDelete);
            let tuple = this.linkDelete.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }
    }
}

ComponentManager.setControl('AssociationBox', AssociationBox, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setControl('AssoziationBox', AssociationBox, 'RADPresentation.HTMLClient.DefaultViewExtensions');